export const gradeGroupTable = [
    { gleasonPrimary: 3, gleasonSecondary: 3, gradeGroup: 1 },
    { gleasonPrimary: 3, gleasonSecondary: 4, gradeGroup: 2 },
    { gleasonPrimary: 4, gleasonSecondary: 3, gradeGroup: 3 },
    { gleasonPrimary: 4, gleasonSecondary: 4, gradeGroup: 4 },
    { gleasonPrimary: 4, gleasonSecondary: 5, gradeGroup: 5 },
    { gleasonPrimary: 3, gleasonSecondary: 5, gradeGroup: 5 },
    { gleasonPrimary: 5, gleasonSecondary: 3, gradeGroup: 5 },
    { gleasonPrimary: 5, gleasonSecondary: 4, gradeGroup: 5 },
    { gleasonPrimary: 5, gleasonSecondary: 5, gradeGroup: 5 }
]